import { useAppSelector } from 'store/hooks';
import { useLazyRetryPaymentQuery } from 'store/payment/service';

import { useLoadData } from './useLoadData';

const useRetry = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { loadData } = useLoadData();
  const [retry, { isLoading }] = useLazyRetryPaymentQuery();

  const handleRetryPayment = async () => {
    if (!paymentData) {
      return false;
    }

    try {
      await retry(paymentData.ID).unwrap();

      await loadData();

      return true;
    } catch (error) {
      console.error('Ошибка при повторной оплате:', error);

      return false;
    }
  };

  return {
    handleRetryPayment,
    isLoading,
  };
};

export { useRetry };
